import 'core-js/stable';
import Vue from 'vue';
import CoreuiVue from '@coreui/vue';
import App from './App';
import router from './router/index';
import { iconsSet as icons } from './assets/icons/icons.js';
import store from './store';
import { storeData, getStoreFromLocalStorage } from './store';
import ApolloClient from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueApollo from 'vue-apollo';
import VModal from 'vue-js-modal';
import 'vue-tree-halower/dist/halower-tree.min.css';
import VTree from 'vue-tree-halower';
import VueCompositionApi, { onErrorCaptured } from '@vue/composition-api';
import CoreuiVueCharts from '@coreui/vue-chartjs';

Vue.use(VueApollo);
Vue.use(CoreuiVueCharts);
Vue.use(VueCompositionApi);
Vue.use(VTree);
Vue.use(CoreuiVue);
Vue.use(VModal);
Vue.prototype.$log = console.log.bind(console);

const link = createHttpLink({
    uri: '',
    fetch
});

const client = new ApolloClient({
    link: link,
    cache: new InMemoryCache({
        addTypename: true
    })
});

const apolloProvider = new VueApollo({
    defaultClient: client,
    defaultOptions: {
        $loadingKey: 'loading'
    }
});

new Vue({
    el: '#app',
    router,
    store,
    client,
    apolloProvider,
    beforeCreate() {
        getStoreFromLocalStorage();
    },
    //CIcon component documentation: https://coreui.io/vue/docs/components/icon
    icons,
    template: '<App/>',
    components: {
        App
    }
});
